import validImg from '../../../../../assets/image/validApiKey.png';

// Links data
export const links = [
  { id: 'intro', label: 'Introduction' },
  { id: 'auth', label: 'Authentication' },
  { id: 'api-key', label: 'API key request' },
  { id: 'dataset', label: 'Get all datasets' },
  { id: 'extraction', label: 'Submit extraction request (LEGACY)' },
  { id: 'request', label: 'Check request status (LEGACY)' },
  { id: 'extraction-v2', label: 'Submit extraction and check status (NEW)' },
  { id: 'download', label: 'Download data' },
];

// Steps data
export const stepsData = [
  {
    title: 'Sign Up',
    description: 'Sign up to MOOD and configure multi factor authentication',
  },
  {
    title: 'Sign In',
    description: 'Sign in to MOOD',
  },
  {
    title: 'Account Info',
    description:
      'Go to your account information by clicking the icon next to your email address (Top right)',
  },
  {
    title: 'Renew API Key',
    description:
      'Click the button to renew the API key and copy your API key for use',
  },
  {
    title: 'Verify',
    description: 'Verify that your API key is valid',
    image: validImg,
  },
];

export const authTitles = ['Exampe request header'];

export const authCode = [
  {
    python: `{
  "ApiKey": "YOUR_API_KEY"
}`,
    matlab: `
options = weboptions('HeaderFields', {'ApiKey', 'YOUR_API_KEY'});`,
  },
];

export const titles = [
  'Check Request Status Code',
  'Example request',
  'Example request body',
  'Example response',
];

export const getAllDatasetTitles = [
  'Check Request Status Code',
  'Example request',
  'Example response',
];

export const getAllDatasetCode = [
  {
    python: `GET https://api.metocean-on-demand.com/api/download/alldataset`,
    matlab: `GET https://api.metocean-on-demand.com/api/download/alldataset`,
  },
  {
    python: `import requests
import json

alldataset_url = "https://api.metocean-on-demand.com/api/download/alldataset"
apiKeyValue = "YOUR_API_KEY"

header = {
  "ApiKey": apiKeyValue
}

print(json.dumps(header,sort_keys=True, indent=4)) #Print request body
alldataset_response = requests.get(alldataset_url , headers=header) #Request
print(json.dumps(alldataset_response.json(),sort_keys=True, indent=4,ensure_ascii=False)) #Print
`,
    matlab: `alldataset_url = 'https://api.metocean-on-demand.com/api/download/alldataset';

% Manually set Authorization header field in weboptions
ApiKeyName = 'ApiKey';
ApiKeyValue = 'YourApiKeyHere';
Timeout = 60;

options = weboptions('HeaderFields',{ApiKeyName,ApiKeyValue},'Timeout',Timeout);

% Make a request using these options
alldataset_response = webread(alldataset_url, options);

alldataset_response %Print response
`,
  },
  {
    python: `{
  "Error": null,
  "Result": [
    {
      "cost": "€0,-/point/year",
      "datasetName": "DWF23-SW-WRF",
      "description": "A validated high accuracy and high resolution metocean dataset for Dutch Wind Farms in the North Sea, developed for the purpose of offshore wind turbine construction. The dataset is generated by DHI's MIKE 21 SW wave model based on a dedicated Atmospheric WRF dataset. The model data is extensively validated against local observations of waves. The model is referred to as SW_DWF23 and described in detail in DHI's report of the Metocean Desk Study for IJmuiden Ver (IJV) Wind Farm Zone, which is available online (https://offshorewind.rvo.nl). The dataset is being certified by DNV-GL.",
      "downloadFormat": ".zip",
      "endTime": "2023-09-30 23:00:00",
      "startTime": "1979-01-01 00:07:00",
      "supportedFormats": ".csv|.nc|.mat|.dfs0"
    },
    {
      "cost": "€0,-/point/year",
      "datasetName": "Global-AT-CFSR",
      "description": "A global high accuracy wind dataset for the period from 1979 until present with hourly values at a spatial resolution of 0.3° during 1979 to 2010, and 0.2° from 2011 and onwards. The spatial resolution of prate, relhum, and SSH is 0.5° throughout the entire dataset period.",
      "downloadFormat": ".zip",
      "endTime": "2024-04-01 00:00:00",
      "startTime": "1979-01-01 00:00:00",
      "supportedFormats": ".csv|.nc|.mat|.dfs0"
    }
  ]
}`,
    matlab: `{
  "Error": null,
  "Result": [
      {
          "cost": "€0,-/point/year",
          "datasetName": "DWF23-SW-WRF",
          "description": "A validated high accuracy and high resolution metocean dataset for Dutch Wind Farms in the North Sea, developed for the purpose of offshore wind turbine construction. The dataset is generated by DHI's MIKE 21 SW wave model based on a dedicated Atmospheric WRF dataset. The model data is extensively validated against local observations of waves. The model is referred to as SW_DWF23 and described in detail in DHI's report of the Metocean Desk Study for IJmuiden Ver (IJV) Wind Farm Zone, which is available online (https://offshorewind.rvo.nl). The dataset is being certified by DNV-GL.",
          "downloadFormat": ".zip",
          "endTime": "2023-09-30 23:00:00",
          "startTime": "1979-01-01 00:07:00",
          "supportedFormats": ".csv|.nc|.mat|.dfs0"
      },
      {
          "cost": "€0,-/point/year",
          "datasetName": "Global-AT-CFSR",
          "description": "A global high accuracy wind dataset for the period from 1979 until present with hourly values at a spatial resolution of 0.3° during 1979 to 2010, and 0.2° from 2011 and onwards. The spatial resolution of prate, relhum, and SSH is 0.5° throughout the entire dataset period.",
          "downloadFormat": ".zip",
          "endTime": "2024-04-01 00:00:00",
          "startTime": "1979-01-01 00:00:00",
          "supportedFormats": ".csv|.nc|.mat|.dfs0"
      }
  ]
}`,
  },
];

export const submitExtractionCode = [
  {
    python: `POST https://api.metocean-on-demand.com/api/download/Extraction`,
    matlab: `POST https://api.metocean-on-demand.com/api/download/Extraction`,
  },
  {
    python: `import requests

extraction_url = "https://api.metocean-on-demand.com/api/download/Extraction"
data = {
  "pointName" : "P3",
  "DatasetName": "Global-AT-CFSR",
  "StartDate": "2017-01-01 00:00:00",
  "EndDate": "2017-12-31 23:00:00",
  "fileformats": ".csv|.dfs0|.mat|.nc",
  "projectiontype": "LngLat",
  "Location": "3.703314, 52.751379"
  #"projectiontype": "UTM",
  #"Easting": "547470",
  #"Northing": "5844846",
  #"UtmZone": "31N"
}
print(json.dumps(data,sort_keys=True, indent=4)) #Print request body
extraction_response = requests.post(extraction_url , headers=header, json=data) #Request
print(json.dumps(extraction_response.json(),sort_keys=True, indent=4)) #Print response
orderid = extraction_response.json()['Result'][0]['orderId']
print(orderid)
`,
    matlab: `extraction_url = 'https://api.metocean-on-demand.com/api/download/Extraction';
extraction_body = struct('DatasetName', 'Global-AT-CFSR',...
  'pointName', 'P3',...
  'StartDate', '2017-01-01 00:00:00',...
  'EndDate', '2017-12-31 23:00:00',...
  'fileformats', '.csv|.dfs0|.mat|.nc',...
  'projectiontype', 'LngLat',...
  'Location', '3.703314, 52.751379' );
  %'projectiontype', 'UTM',
  %'Easting', '547470',
  %'Northing', '5844846',
  %'UtmZone', '31N'

extraction_body % Print extraction_body

extraction_response = webwrite(extraction_url, extraction_body, options);

extraction_response % Print Extraction_response

orderid = extraction_response.Result.orderId;
`,
  },
  {
    python: `{
  "DatasetName": "Global-AT-CFSR",
  "Easting": "547470",
  "EndDate": "2017-12-31 23:00:00",
  "Northing": "5844846",
  "StartDate": "2017-01-01 00:00:00",
  "UtmZone": "31N",
  "fileformats": ".csv|.dfs0|.mat|.nc",
  "projectiontype": "UTM"
}`,
    matlab: `{
  "DatasetName": "Global-AT-CFSR",
  "Easting": "547470",
  "EndDate": "2017-12-31 23:00:00",
  "Northing": "5844846",
  "StartDate": "2017-01-01 00:00:00",
  "UtmZone": "31N",
  "fileformats": ".csv|.dfs0|.mat|.nc",
  "projectiontype": "UTM"
}
`,
  },
  {
    python: `{
  "Error": null,
  "Result": [
    {
      "datasetName": "Global-AT-CFSR",
      "datasetResult": null,
      "datasetType": null,
      "orderId": "MoodApiV2_58733c08-799a-46a5-8dbe-4e22ce6b89a9_20240807_214029"
    }
  ]
}`,
    matlab: `{
  "Error": null,
  "Result": [
      {
          "datasetName": "Global-AT-CFSR",
          "datasetResult": null,
          "datasetType": null,
          "orderId": "MoodApiV2_58733c08-799a-46a5-8dbe-4e22ce6b89a9_20240807_214029"
      }
  ]
}
`,
  },
];

export const checkRequestStatusCode = [
  {
    python: `GET https://api.metocean-on-demand.com/api/download/Status`,
    matlab: `GET https://api.metocean-on-demand.com/api/download/Status`,
  },
  {
    python: `import requests

status_url = "https://api.metocean-on-demand.com/api/download/Status"

orderid = extraction_response.json()['Result'][0]['orderId']

status_data = {
  "orderid": orderid
}

print(json.dumps(status_data,sort_keys=True, indent=4)) #Print request body

status_response = requests.get(status_url, headers=header, params=status_data) #Request
print(json.dumps(status_response.json(),sort_keys=True, indent=4)) #Print response
result_url = status_response.json()['Result']['result']
print(result_url)
`,
    matlab: `status_url = 'https://api.metocean-on-demand.com/api/download/Status';

status_body = struct('orderid', orderid);%orderid = extraction_response.Result.orderId
status_body %Print status body
status_response = webread(status_url, 'orderid', orderid, options);

status_response %Print status response
`,
  },

  {
    python: `{
  "Error": null,
  "Result": {
    "result": "https://www.metocean-on-demand.com/downloadfileshare/getfile.ashx?order_id=MoodApiV2_58733c08-798a-46a5-8dbe-4e22ce6h75a9_20240807_214029&file_name=user@company.com_20240807_214073_Results.zip",
    "status": "Completed"
  }
}`,
    matlab: `{
  "Error": null,
  "Result": {
    "result": "https://www.metocean-on-demand.com/downloadfileshare/getfile.ashx?order_id=MoodApiV2_58733c08-798a-46a5-8dbe-4e22ce6h75a9_20240807_214029&file_name=user@company.com_20240807_214073_Results.zip",
    "status": "Completed"
  }
}`,
  },
];

export const extractionV2 = [
  {
    python: `POST https://api.metocean-on-demand.com/api/download/Extraction/RunBackground`,
    matlab: `POST https://api.metocean-on-demand.com/api/download/Extraction/RunBackground`,
  },
  {
    python: `import time
import json
import requests

extraction_url = "https://api.metocean-on-demand.com/api/download/Extraction/RunBackground"
status_url = "https://api.metocean-on-demand.com/api/download/Status"

header = {
  "ApiKey": apiKeyValue
}

data = {
  "pointName": "P3",
  "DatasetName": "Global-AT-CFSR",
  "StartDate": "2017-01-01 00:00:00",
   "EndDate": "2017-12-31 23:00:00",
   "fileformats": ".csv|.dfs0|.mat|.nc",
   "projectiontype": "LngLat",
   "Location": "3.703314, 52.751379"
}

def start_extraction():
   resp = requests.post(extraction_url, headers=header, json=data)
   payload = resp.json()

   if payload["Error"]:
      raise Exception(f"Extraction error: {payload['Error']}")

   return payload["Result"][0]["orderId"]

def check_status(order_id):
   params = {"orderid": order_id}
   resp = requests.get(status_url, headers=header, params=params)
   payload = resp.json()
   print("Status response:", json.dumps(payload, indent=4))

   return payload["Result"]

order_id = start_extraction()
print(f"Order ID: {order_id}")

attempt = 0
max_attempts = 60
wait_seconds = 2

status_info = {"status": "InProgress"}

while status_info["status"] == "InProgress" and attempt < max_attempts:
   status_info = check_status(order_id)

   attempt += 1

   if status_info["status"] != "InProgress":
      break

   time.sleep(wait_seconds)

result_url = status_info["result"] # "https://www.metocean-on-demand.com/downloadfileshare/getfile.ashx?order_id=MoodApiV2_xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx_xxxxxxxx_xxxxxx&file_name=user@company.com_20251120_133030_Results.zip"
`,
    matlab: `extraction_url = 'https://api.metocean-on-demand.com/api/download/Extraction/RunBackground';
status_url = 'https://api.metocean-on-demand.com/api/download/Status';

options = weboptions('HeaderFields', {'ApiKey', ApiKeyValue });

extraction_body = struct( ...
  'DatasetName', 'Global-AT-CFSR', ...
  'pointName', 'P3', ...
  'StartDate', '2017-01-01 00:00:00', ...
  'EndDate', '2017-12-31 23:00:00', ...
  'fileformats', '.csv|.dfs0|.mat|.nc', ...
  'projectiontype', 'LngLat', ...
  'Location', '3.703314, 52.751379' ...
);

extraction_response = webwrite(extraction_url, extraction_body, options);
orderId = extraction_response.Result(1).orderId;
fprintf("Order ID: %s", orderId);

maxAttempts = 60;
attempt = 0;
finalStatus = "InProgress";
download_url = "";

while (attempt < maxAttempts) && (finalStatus == "InProgress")
    status_response = webread(status_url, 'orderid', orderId, options);
    finalStatus = string(status_response.Result.status);

    if finalStatus ~= "InProgress"
        break;
    end

    pause(2);
    attempt = attempt + 1;
end

if finalStatus == "Done"
    download_url = status_response.Result.result;
    fprintf("Download URL: %s", download_url);
end
`,
  },
  {
    python: ``,
    matlab: ``,
  },
  {
    python: `{
   "Result":{
      "status":"Done",
      "result":"https://www.metocean-on-demand.com/downloadfileshare/getfile.ashx?order_id=MoodApiV2_xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx_xxxxxxxx_xxxxxx&file_name=user@company.com_API_20251120_133030_Results.zip"
   },
   "Error":null
}`,
    matlab: `{
   "Result":{
      "status":"Done",
      "result":"https://www.metocean-on-demand.com/downloadfileshare/getfile.ashx?order_id=MoodApiV2_xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx_xxxxxxxx_xxxxxx&file_name=user@company.com_20251120_133030_Results.zip"
   },
   "Error":null
}
`,
  },
];

export const downloadDataCode = {
  python: `# pip install pyautogui
import urllib.request
import pyautogui
import os

filename = result_url[79:]
folder = ".//"

if os.path.isfile(folder+filename):
	answer=pyautogui.confirm('The file already exists. Do you want to overwrite the file?', buttons=['Yes', 'No, define a new name.'])
	if answer=='Yes':
		filedownload = urllib.request.URLopener()
		filedownload.retrieve(result_url, folder+filename)
	else:
		newfilename=pyautogui.prompt(text='Enter a new file name', title='Define file name' , default='')
		while newfilename=='':
			newfilename=pyautogui.prompt(text='Enter a new file name', title='Define file name' , default='')
		else:
			if newfilename==None:
				print('No file downloaded')

			else:
				while os.path.isfile(folder+newfilename):
					newfilename=pyautogui.prompt(text='The file name is exists. Please re-enter a new name.', title='Re-enter file name' , default='')
				else:
					filedownload = urllib.request.URLopener()
					filedownload.retrieve(result_url, folder+newfilename)
					print ('File downloaded')

else:
	filedownload = urllib.request.URLopener()
	filedownload.retrieve(result_url, folder+filename)
	print ('File downloaded')
`,
  matlab: `%Download data
%--------------------------------------------------------------------------
download_url = [(status_response.Result.result)];

filename = download_url(80:end);

if isempty(download_url)
%Use for points outside the domain
    f = msgbox('Error occured in data extraction', 'Error','error');
    disp('Please verify date and location within data range. If this still happens, please contact our administrator for help. ')
elseif isfile(filename)
    answer = questdlg('File name already exists, choose a new file name?', ...
    'Options', ...
    'Yes','No','Yes');
    % Handle response
    switch answer
        case 'Yes'
    %Ask user input
    prompt = {'Enter filename'};
    dlgtitle = 'Input';
    dims = [1 35];
    definput = {'yournewfilename.zip'};
    answer = inputdlg(prompt,dlgtitle,dims,definput);
    filename = answer{1};
        case 'No'
            filename = download_url(80:end);
            f = msgbox('Operation Completed','Success');
    end
end
options.Timeout=Inf;
outfilename = websave(filename,download_url,options);
`,
};

export const datasetTable = {
  columns: [
    {
      title: 'Header Name',
      dataIndex: 'property',
      key: 'property',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
  ],
  dataSource: [
    {
      key: 1,
      property: 'ApiKey',
      description: 'The valid Api key obtained from user account information.',
    },
  ],
};

export const extractionTable = {
  columns: [
    {
      title: 'Property',
      dataIndex: 'property',
      key: 'property',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
  ],
  dataSource: [
    {
      key: 1,
      property: 'DatasetName',
      description:
        'The name of the dataset. The name should be the same as one of the results from "Get all dataset".',
    },
    {
      key: 2,
      property: 'ProjectionType',
      description: 'The projection type. Value = "LngLat" or "UTM".',
    },
    {
      key: 3,
      property: 'StartDate',
      description: 'The start date with format "yyyy-MM-dd HH:mm:ss".',
    },
    {
      key: 4,
      property: 'EndDate',
      description: 'The end date with format "yyyy-MM-dd HH:mm:ss".',
    },
    {
      key: 5,
      property: 'FileFormats',
      description:
        'The result file formats, separated by "|". Currently 4 formats are supported: ".csv|.dfs0|.mat|.nc".',
    },
    {
      key: 6,
      property: 'Location',
      description:
        '(required for ProjectionType="LngLat") The location string with format "lng,lat".',
    },
    {
      key: 7,
      property: 'Easting',
      description: '(required for ProjectionType="UTM") The easting value.',
    },
    {
      key: 8,
      property: 'Northing',
      description: '(required for ProjectionType="UTM") The northing value.',
    },
    {
      key: 9,
      property: 'UtmZone',
      description: '(required for ProjectionType="UTM") The utm zone value.',
    },
  ],
};

export const statusTable = {
  columns: [
    {
      title: 'Property',
      dataIndex: 'property',
      key: 'property',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
  ],
  dataSource: [
    {
      key: 1,
      property: 'OrderId',
      description: 'The order ID returned from "Submit extraction request".',
    },
  ],
};
